export { default } from './PrismicLink';
